import { createAction } from '@reduxjs/toolkit';

// Interfaces
import { Constants } from './constants';

export const showSidebar = createAction(Constants.SIDEBAR_SHOW);

export const hideSidebar = createAction(Constants.SIDEBAR_HIDE);
